/**
 * Active conversation (`/conversations/$id`).
 *
 * Renders the shared `ChatView` bound to the `$id` route param. The message
 * stream comes from `users/{uid}/conversations/{id}/messages` in real time.
 */
import { useParams } from '@tanstack/react-router'

import { ChatView } from '@/components/chat/chat-view'

export function ConversationRoute() {
  const { id } = useParams({ from: '/_authenticated/conversations/$id' })
  // No `key={id}` on purpose: keeping ChatView mounted across conversation
  // switches keeps the sidebar stable and lets the message pane crossfade
  // (see ChatView) instead of the whole view remounting abruptly.
  return <ChatView conversationId={id} />
}

export default ConversationRoute
